"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Clipboard = function Clipboard(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ClipboardTitle ClipboardDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ClipboardTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ClipboardDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M10.626 3.717v-1.47c0-.281.18-.47.451-.47h10.735c.27 0 .45.189.45.47v1.47h7.304c.273 0 .454.185.454.463v25.626c0 .231-.227.416-.454.416H2.676c-.272 0-.454-.185-.454-.462V4.18c0-.278.182-.463.454-.463h7.95zm0 .925H3.131v24.701h25.935v-24.7h-6.803v1.883c0 .235-.226.423-.451.423H11.077c-.27 0-.45-.188-.45-.47V4.642zM8.04 17.94a.646.646 0 1 1 0-1.293.646.646 0 0 1 0 1.293zm0-5.818a.646.646 0 1 1 0-1.293.646.646 0 0 1 0 1.293zm0 11.637a.646.646 0 1 1 0-1.293.646.646 0 0 1 0 1.293zm8.564 0h-3.552c-.292 0-.486-.13-.486-.324s.194-.323.486-.323h3.552c.292 0 .487.13.487.323 0 .194-.243.324-.487.324zm0-5.819h-3.552c-.292 0-.486-.129-.486-.323s.194-.323.486-.323h3.552c.292 0 .487.13.487.323 0 .194-.243.323-.487.323zm0-5.818h-3.552c-.292 0-.486-.13-.486-.323 0-.194.194-.323.486-.323h3.552c.292 0 .487.129.487.323s-.243.323-.487.323zM11.528 6.01h9.833V2.72h-9.833v3.29z",
    id: "refClipboardBSj0iF2xfeA"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refClipboardBSj0iF2xfeA"
  }));
};

Clipboard.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Clipboard.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Clipboard;
exports["default"] = _default;